import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(() => ({
	listItemTitle: {
		flex: 1,
		textTransform: "capitalize",
		lineHeight: "19px",
		wordWrap: "break-word"
	},
	icon: {
		width: "28px",
		height: "28px"
	}
}))

export default useStyles
